import React, { useCallback, useState } from 'react'
import styled from 'styled-components/macro'
import { Container, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import GenericNotice from 'src/components/GenericNotice/GenericNotice'
import RouteContainer from 'src/components/App/RouteContainer'
import { Certificate } from 'types/certification'

const CertificatesList = React.lazy(() => loadComponent('certification', 'CertificateList'))
const CertificateCreateModal = React.lazy(() => loadComponent('certification', 'CertificateCreateModal'))

const StyledButton = styled(Button)`
    float: right;
`

const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`

const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function CertificateIndexRoute() {
    const navigate = useNavigate()
    const { academy, openFlightDeck } = useFlightDeck()

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)

    const canCreate = usePermission('certification.certificate.create', { academy: academy?._id! })
    const canDelete = usePermission('certification.certificate.delete', { academy: academy?._id! })

    const onSelect = useCallback(
        (certificate: Certificate) => {
            navigate(certificate._id)
        },
        [navigate],
    )

    const onCreate = useCallback(() => {
        setIsCreateModalOpen(true)
    }, [])

    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                <StyledHeadingText variant="h4">Zertifikate</StyledHeadingText>
                {canCreate && (
                    <StyledButton variant="contained" color="primary" onClick={() => onCreate?.()} startIcon={<Add />}>
                        neu
                    </StyledButton>
                )}
            </StyledHeaderContainer>
            {!academy ? (
                <>
                    <GenericNotice
                        title="Keine Akademie ausgewählt"
                        message="Zertifikate gehören immer zu einer Akademie. Bitte wähle eine Akademie im Flight Deck aus, um dessen Zertifikate zu sehen">
                        <Button variant="contained" onClick={openFlightDeck}>
                            Flight Deck öffnen
                        </Button>
                    </GenericNotice>
                </>
            ) : (
                <>
                    <CertificatesList key={isCreateModalOpen} academyId={academy?._id} onSelect={onSelect} canDelete={canDelete} />
                    <CertificateCreateModal
                        isOpen={isCreateModalOpen}
                        academyId={academy._id}
                        onCancel={() => setIsCreateModalOpen(false)}
                        onCreate={() => setIsCreateModalOpen(false)}
                    />
                </>
            )}
        </RouteContainer>
    )
}
